module.exports = __webpack_public_path__ + "img/map@2x-100.1e5893fc.jpg";